/*
The axios instance for the front end
 */

import axios from "axios";

const api = axios.create({
  baseURL: '/wp-json/',
  headers: {
    'Content-Type': 'application/json',
    'X-WP-Nonce': g2rObj.nonces.wp,
  },
  // params: {g2rNonce: g2rObj.nonces.nonce}
});

api.CancelToken = axios.CancelToken;
api.isCancel = axios.isCancel;

api.interceptors.request.use((config) => {
  if (['post', 'patch', 'put'].includes(config.method)) {
    config.data.g2rNonce = g2rObj.nonces.nonce;
  }
  if (['get', 'delete'].includes(config.method)) {
    config.params = config.params || {};
    config.params.g2rNonce = g2rObj.nonces.nonce;
  }
  return config;
});

api.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (undefined === error.response) {
    return Promise.reject('Undefined server response')
  } else {
    // console.error(error.response)
    if (error.response.status >= 400) {
      // console.log(error.response)
      if (error.response.data.hasOwnProperty('message')) {
        alert(error.response.data.message);
      } else if (typeof error.response.data === "string") {
        alert(`Un problème est survenu : ${error.response.data}`);
      } else if (Array.isArray(error.response.data)) {
        alert(`Un problème est survenu : ${error.response.data.join(',')}`);
      } else {
        alert(`Un problème est survenu. Nous sommes désolé pour la gêne occasionnée.`);
      }
    } else {
      alert(`Un problème est survenu. Nous sommes désolé pour la gêne occasionnée.`);
    }
    return Promise.reject(error);
  }
});

export default api;
